<!--
 * @Author: Alfred huqitaoit@gmail.com
 * @Date: 2023-12-15 14:56:36
 * @LastEditors: Alfred
 * @LastEditTime: 2023-12-15 15:04:51
 * @Description:
 * @FilePath: \src\components\order\OrderRefundAuditInfo.vue
-->
<template>
  <div class="order-refund-info">
    <div class="order-detail-item order-detail-status">
      <div class="order-detail-audit-status">
        <div class="color-black bold">
          订单审核状态：{{ orderDetail.refundInfo.status_name }}
        </div>
      </div>
    </div>
    <div class="order-detail-item">
      <div class="color-black bold font-size16 order-detail-item-title">
        学员信息
      </div>
      <div class="order-detail-student">
        <div class="order-detail-people-name">
          <span
            class="order-detail-student-name"
          >学员姓名： {{ orderDetail.subInfo.sub_name }}</span>
          <span>就读小学：{{ orderDetail.subInfo.school_name }}</span>
          <span>就读年级：{{ orderDetail.subInfo.grade_name }}</span>
        </div>
        <div class="order-detail-people-name">
          <span
            class="order-detail-student-name"
          >家长姓名：{{ orderDetail.masterInfo.master_name }}</span>
          <span>家长电话：<MobileHidden :params="{sub_id: orderDetail.subInfo.sub_id }" :encrypt="orderDetail.masterInfo.mobile" /> </span>
        </div>
      </div>
    </div>
    <!-- 退款 -->
    <div class="order-detail-item">
      <div class="color-black bold font-size16 order-detail-item-title">
        退款套餐信息
      </div>
      <div class="order-detail-package">
        <div
          v-for="(item, index) in orderDetail.orderList"
          :key="index"
          class="order-refund-list"
        >
          <div class="order-detail-people-name">
            <span>签约单号：{{ item.order_id }}</span>
          </div>
          <table class="special-table">
            <thead>
              <tr>
                <th>类型</th>
                <th>订单课时（天）</th>
                <th>已上课时（天）</th>
                <th>退费课时（天）</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(itemChild, childIndex) in item.list"
                :key="childIndex"
              >
                <td>{{ itemChild.key_summary }}</td>
                <td>{{ itemChild.days }}</td>
                <td>{{ itemChild.consume_days }}</td>
                <td>{{ itemChild.days - itemChild.consume_days }}</td>
              </tr>
              <tr>
                <td colspan="4" style="text-align:left;padding-left:30px">
                  <span>退款金额：￥{{ item.refund_amount / 100 }}</span>
                </td>
              </tr>
              <tr v-if="item.invoice_status == '1'">
                <td colspan="4" style="text-align:left;padding-left:30px">
                  <span>
                    发票信息：{{
                      item.invoice_status == "1" ? "已归还" : "未归还"
                    }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="order-detail-item">
      <div class="color-black bold font-size16 order-detail-item-title">
        退款信息
      </div>
      <div class="order-detail-package">
        <div class="color-danger">
          总退费金额：¥{{ orderDetail.refundInfo.amount / 100 }}
        </div>
      </div>
    </div>
    <div class="order-detail-item">
      <div class="color-black bold font-size16 order-detail-item-title">
        责任人信息
      </div>
      <div class="order-detail-sales">
        <div class="order-detail-people-name">
          <span>退费操作人：{{ orderDetail.refundInfo.editor_name }}</span>
          <span>责任人：{{ orderDetail.refundInfo.headmaster_name }}</span>
        </div>
      </div>
    </div>
    <!-- 退款审核显示 -->
    <div v-if="type == 'refundAudit'" class="order-audit-btn">
      <el-row type="flex" justify="end">
        <el-input
          v-model="remark"
          clearable
          placeholder="请输入失败原因"
        />
        <el-button type="danger" @click="failRefund">审核失败</el-button>
        <el-button type="primary" @click="successRefund">审核成功</el-button>

      </el-row>
    </div>
  </div>
</template>

<script>
import MobileHidden from '@/components/MobileHidden';

export default {
  name: 'OrderRefundAuditInfo',
  components: {
    MobileHidden
  },
  props: {
    orderDetail: Object,
    type: String
  },
  data() {
    return {
      remark: '',
      audit_status: ''
    }
  },
  methods: {
    failRefund() {
      if (!this.remark) {
        this.$message({
          type: 'info',
          message: '请输入失败原因'
        })
        return
      }
      const obj = {
        refund_id: this.orderDetail.refundInfo.refund_id,
        remark: this.remark,
        audit_status: 'fail'
      }
      this.$http.auditRefund(obj).then(res => {
        if (res.code == 200) {
          this.$emit('updateOrderList')
        }
      })
    },
    successRefund() {
      const obj = {
        refund_id: this.orderDetail.refundInfo.refund_id,
        audit_status: 'success'
      }
      this.$http.auditRefund(obj).then(res => {
        if (res.code == 200) {
          this.$emit('updateOrderList')
        }
      })
    }
  }
}
</script>

<style lang="scss">
.order-detail-dialog .el-dialog__body {
  height: 700px;
  padding: 20px 30px;
  overflow: auto;
  .order-refund-info {
    line-height: 24px;
    .order-detail-item {
      margin-bottom: 20px;
      padding-bottom: 20px;
      border-bottom: 1px solid #f5f5f5;
    }
    .order-detail-status {
      padding: 15px 20px;
      background-color: #f5f5f5;
    }
    .order-detail-item-title {
      margin-bottom: 15px;
    }
    .order-detail-people-name span {
      margin-right: 30px;
    }
    .order-detail-student-name {
      width: 160px;
    }
    .el-table {
      margin-top: 10px;
    }
    .el-table tr th {
      height: 34px !important;
      background: #fff !important;
      color: #333;
    }
    .el-table td,
    .el-table th {
      padding: 4px;
      border: 1px solid #f5f5f5;
    }
  }
  .order-audit-btn {
    .el-row {
      margin-bottom: 10px;
    }
    .el-input {
      margin-right: 20px;
    }
  }
  .order-refund-list {
    margin-bottom: 20px;
  }
  .special-table {
    width: 100%;
    margin: 10px 0;
    border: 1px solid #f5f5f5;
    tr,
    th,
    td {
      text-align: center;
      padding: 10px 0;
      border: 1px solid #f5f5f5;
    }
  }
}
</style>
